module.exports = __webpack_public_path__ + "img/scanner_gun_scan.0d6aac9b.svg";